<template>
    <div>
        <h3>Aguarde...</h3>
    </div>
</template>

<script>
export default {
    name: 'RedirectPage',
    created() {
        this.redirectTo()
    },
    methods: {
        redirectTo() {

            if(!this.$route.params.rotaDestino){
                this.$router.push({name: 'licitacaoBusca'})
                return
            }

            let rotaDestino = this.$route.params.rotaDestino;
            rotaDestino = this.validarRedirectToPregaoAbertoFechado(rotaDestino)

            const hostname = window.location.hostname
            const protocol = window.location.protocol
            rotaDestino = protocol + '//' + hostname + rotaDestino

            window.open(rotaDestino, '_self');
        },
        validarRedirectToPregaoAbertoFechado(rotaDestino){

            if(rotaDestino.includes('pregao-pregoeiro=')){
                return rotaDestino.replace('pregao-pregoeiro=', '/pregao/#/pregoeiro/pregao=') + '/lances'
            }else if(rotaDestino.includes('pregao-licitante=')){
                return rotaDestino.replace('pregao-licitante=', '/pregao/#/licitante/pregao=') + '/lances'
            }
        }
    }
}
</script>

<style scoped lang="stylus">

</style>